import { trackUsage } from '../services/usageTracker';
import { extrahiereProgrammeId } from './usageRoute';

/** Dateiendung in Kleinbuchstaben, z. B. "xlsx" (Fallback "unbekannt"). */
export function formatAusDateiname(dateiname: string): string {
  const idx = dateiname.lastIndexOf('.');
  return idx === -1 || idx === dateiname.length - 1 ? 'unbekannt' : dateiname.slice(idx + 1).toLowerCase();
}

export function base64ZuBlob(base64: string, mimeType: string): Blob {
  const bin = atob(base64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], { type: mimeType });
}

/**
 * Zentraler Download-Helfer für Core-Exporte: löst den Download aus und erfasst
 * ein `export`-Ereignis (nur Format, keine Inhalte).
 */
export function ladeDateiHerunter(blob: Blob, dateiname: string, format?: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = dateiname;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
  trackUsage({
    eventType: 'export',
    route: typeof window !== 'undefined' ? window.location.pathname : undefined,
    programmeId: typeof window !== 'undefined' ? extrahiereProgrammeId(window.location.pathname) : null,
    details: { format: format ?? formatAusDateiname(dateiname) },
  });
}
